module.exports = __webpack_public_path__ + "img/aavc.265ac29e.jpg";